// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-md[data-v-ac1c911a] {\n  font-size: 18px;\n  color: #1A7BEE;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14.4px;\n  cursor: pointer;\n}\n.collapse-item[data-v-ac1c911a] {\n  /* width: 400px; */\n  /* border-right: 1px solid #1A7BEE !important; */\n}\n.grow[data-v-ac1c911a] {\n  -webkit-box-flex: 1 !important;\n      -ms-flex-positive: 1 !important;\n          flex-grow: 1 !important;\n}\n", ""]);
// Exports
module.exports = exports;
